var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cva } from 'class-variance-authority';
import { classNames as cn } from '../utils';
const tabsListVariants = cva('bg-muted text-muted-foreground inline-flex w-fit items-center justify-center rounded-xl p-[3px] gap-1', {
    variants: {
        size: {
            sm: 'h-7',
            default: 'h-9',
            lg: 'h-11',
            adaptive: 'h-full',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});
const tabsTriggerVariants = cva('dark:data-[state=active]:text-base-900 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 text-base-500 dark:text-muted-foreground data-[state=active]:text-base-900 hover:bg-base-50 inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-[8px] border border-transparent font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0', {
    variants: {
        size: {
            sm: 'px-1.5 py-0.5 text-xs [&_svg:not([class*="size-"])]:size-3',
            default: 'px-2 py-1 text-sm [&_svg:not([class*="size-"])]:size-4',
            lg: 'px-3 py-1.5 text-base [&_svg:not([class*="size-"])]:size-5',
            adaptive: 'px-2 py-1 text-sm [&_svg:not([class*="size-"])]:size-4',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});
export function Tabs(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(TabsPrimitive.Root, Object.assign({ "data-slot": "tabs", className: cn('bg-base-100 flex flex-col gap-2 rounded-xl', className) }, props)));
}
export function TabsList(_a) {
    var { className, size } = _a, props = __rest(_a, ["className", "size"]);
    return (_jsx(TabsPrimitive.List, Object.assign({ "data-slot": "tabs-list", className: cn(tabsListVariants({ size }), className) }, props)));
}
export function TabsTrigger(_a) {
    var { className, size } = _a, props = __rest(_a, ["className", "size"]);
    return (_jsx(TabsPrimitive.Trigger, Object.assign({ "data-slot": "tabs-trigger", className: cn(tabsTriggerVariants({ size }), className) }, props)));
}
export function TabsContent(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(TabsPrimitive.Content, Object.assign({ "data-slot": "tabs-content", className: cn('flex-1 outline-none', className) }, props)));
}
